<template>
	<div class="expanded expanded--columns expanded--mental" :class="expand ? 'active' : ''">
		<div v-show="!reaction" class="game mental mental--main" :style="users > 1 ? 'border-color:' + colors[inkey] : ''">
			<button class="expanded__button" v-if="params.users === 1" @click="expand = !expand" :uk-tooltip="expand ? 'Свернуть' : 'Развернуть'"></button>
			<!--<div class="mental__table">
				<div class="uk-overflow-auto">
					<table class="">
						<tr>
							<th></th>
							<th class="uk-text-center" v-for="(c, k) in ['-9', '-8', '-7', '-6', '-5', '-4', '-3', '-2', '-1', '0','1','2','3','4','5','6','7','8','9']">{{ c }}</th>
						</tr>
						<tr v-for="(row, r_key) in table">
							<td><strong style="color:red">{{ r_key }}</strong></td>
							<td v-for="(column, c_key) in row">
								<div>{{ column }}</div>
							</td>
						</tr>
					</table>
				</div>
			</div>-->
			<div class="train__info uk-margin-bottom" v-if="users === 1">
				<div class="train__item" uk-tooltip="Шаг">
					<div class="train__ico train__ico--1"></div>
					<small>Шаг:</small>
					{{ local_steps }}
				</div>
				<div class="train__item" uk-tooltip="Ошибок сделано">
					<div class="train__ico train__ico--2"></div>
					<small>Ошибок:</small>
					{{ errors }}
				</div>
				<div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено">
					<div class="train__ico train__ico--4"></div>
					<small>Выполнено:</small>
					<div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
				</div>
				<div class="train__item" uk-tooltip="Времени прошло">
					<div class="train__ico train__ico--3"></div>
					<span><small>Времени прошло:</small>
					{{ timer.minutes }} мин. {{ timer.seconds }} сек.</span>
				</div>
			</div>
			<div class="game__name" v-if="role === 'teacher'">
				Игрок {{ inkey }}
				<!--<div class="game__settings" :uk-toggle="'target: #settingsmodal-'+inkey"></div>-->
				<div class="game__settings" @click="setShowsettings"></div>
			</div>

			<div class="mental__body" v-if="currentStep == 'preStart'">
				<button class="uk-button uk-button-primary" :id="'start-' + inkey" @click="startApp(false)">Начать!</button>
			</div>

			<div class="mental__body countdown" v-if="currentStep == 'ready'" :style="'font-size: calc(53px / 1.' + (users > 9 ? 99 : users) + ')'">
				<small :style="'font-size: calc(35px / 1.' + (users > 9 ? 99 : users) + ')'">Приготовились!</small>
				<br>
				{{ cd[countDownCifs] }}
			</div>
			<!--<div class="cifers odd" :style="'font-size: calc(182px / (1.' + users + ' + 0.' + maxAxis + 2 +'));'">234</div>-->
			<!--<div class="cifers" :class="dots % 2 === 0 ? 'odd' : 'even'" :style="'font-size: calc(182vh / ' + params.terms + ');'" v-if="currentStep == 'cifers'">-->
			<div class="mental__body cifers" :class="dots % 2 === 0 ? 'odd' : 'even'" v-if="currentStep == 'cifers'" :style="'font-size: calc(172px / (1.' + (users > 9 ? 99 : users) + ' + 0.' + maxAxis + 2 +'));'">
				{{ currentCif }}
			</div>
			<div class="mental__body answer uk-margin-top" v-if="currentStep == 'answer'">
				<div v-if="is_error" class="flash__message flash__error flash__message--new">Неправильно! <span class="mental__checks active"></span></div>
				<div v-if="is_success" class="flash__message flash__success flash__message--new">Правильно! <span class="mental__checks"></span></div>
				<div class="">
					<input type="tel" class="game_input uk-input" :id="'game_input-' + inkey" autocomplete="off" @keyup.enter="checkAnswer2" v-model="userNumber" placeholder="Введите ответ">
				</div>
				<button class="uk-button uk-button-primary" @click="checkAnswer">ОТВЕТИТЬ</button>
			</div>
			<div class="mental__body repeat" v-if="currentStep == 'result'">
				<!--<p>Формулы: {{ params.formula }}</p>-->
				<p>Ваши результаты:</p>
				<div v-for="(result, key) in results" class="mental_results">
          <div class="mental_result" v-if="results.length === 1">
            <span :class="isRight(result) ? '' : 'wrong'">{{ isRight(result) ? 'ПРАВИЛЬНО!' : 'НЕПРАВИЛЬНО!' }}</span>
          </div>
					<p><strong>Шаг: {{ key+1 }}: </strong>
						<span v-for="(cif, key) in result.cifers">{{(key > 0 && cif > 0) ? ' + ' : ' '}}{{ cif > 0 ? cif : '- ' + -cif }}</span>
            = <span class="mental_results__result">{{ result.sum }}</span>, <span class="mental_results__answblock">Ваш ответ: <span class="mental_results__answer" :class="isRight(result) ? '' : 'wrong'">{{ result.user_answer }}</span>
						<span class="mental__checks" :class="isRight(result) ? '' : 'active'"></span></span></p>
				</div>
				<p class="scores">Ты зарабатываешь
					<strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
				<button class="uk-button uk-button-primary" :id="'repeat-' + inkey" @click="fullReset" v-if="!checkHomeworkFinish()">Повторить!</button>
				<button class="uk-button uk-button-primary" :id="'repeat-' + inkey" @click="onStopTrainer" v-else>Закончить</button>
			</div>
			<a v-if="role !== 'teacher'" href="#" @click.prevent="onStopTrainer">Остановить</a>

			<div class="modsettings" v-if="showsettings">
				<div class="modsettings__back" @click="setShowsettings"></div>
				<div class="modsettings__body">
					<h2>Настройки тренажера Игрока {{ inkey }}</h2>
					<div class="instructions">
						<settings :inparams="params" :ingame="true" @params_changed="params_changed"></settings>
					</div>
				</div>
			</div>
		</div>

		<!--РЕАКЦИИ-->
		<div class="wh-block wh-block--reaction" v-if="reaction">
			<div class="reaction">
				<!--<video loop muted preload="auto" autoplay @ended="reaction = !reaction">-->
				<video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
					<source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
				</video>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { mix } from "./../mixin";
  import { mental_mix } from "./mental_mixin";
  import { soundMix } from "../../../mixins/sound";
  import settings from "./components/Settings";
  import Select2 from "v-select2-component";
  import axios from "axios";

  export default {
    name: "game",
    mixins: [
      mix, mental_mix, soundMix
    ],
    components: { Select2, settings },
    data() {
      return {
        expand: false,
        preStart: false,
        reaction: false,
        reaction_file: '',
        active: false,
        /** Шаги в случае ряда примеров */
        step: 1,
        local_steps: 0,
        scores: 0,
        /** Ошибок */
        errors: 0,
        /** Массив сгенерированных чисел */
        cifers: '',
        /** Сумма */
        sum: '',
        /** Ответ пользователя */
        userNumber: '',
        /** Цифры обратного отсчета */
        countDownCifs: 2,
        /** Точки - показ количества слагаемых */
        dots: 0,
        odd_even: 'odd',
        /** Текущая цифра */
        currentCif: '',
        /** Текущий шаг */
        currentStep: '',
        /** В случае ошибки */
        is_error: false,
        /** В случае успеха */
        is_success: false,
        results: [],
        local_results: [],
        stat_id: '',
        voice: '',
        sound: 'mental',
        timerId: null,
        cd: [
          'Марш!', 'Внимание!', 'На старт!'
        ],
        showsettings: false,
        params: '',
        finish: false
      }
    },
    computed: {
      ...mapState({
        //params: state => state.train.mental_params
      }),
      colors() {
        return this.$store.state.colors;
      },
      /*finish() {
        return this.$store.state.train.mental_params.finish;
      },*/
      user() {
        return this.$store.state.user;
      },
      users() {
        return this.$store.state.train.mental_params.users
      },
      role() {
        return this.user.role.code;
      }
    },
    props: {
      inkey: ''
    },
    /* watch:{
			 'users': 'checkStarts'
		 },*/
    methods: {
      /**
       * ФУНКЦИИ ИГРЫ
       * */

      isRight(result){
        return +result.user_answer === +result.sum;
      },

      /** Начать игру */
      startGame(nocd) {
        this.userNumber = '';
        this.dots = 0;
        //this.currentStep = 'ready';
        this.currentStep = 'ready';
        if (!nocd) {
          this.countDown();
        } else {
          this.showCifers();
        }
      },
      /** Обратный отсчет */
      countDown() {
        //this.playMentalSound(523.25);
        this.start_play('3');
        this.timerId = setInterval(() => {
          console.log(this.countDownCifs);
          if (+this.countDownCifs !== 0) {
            this.start_play(this.countDownCifs.toString());
            //this.playMentalSound(523.25);
          }
          +this.countDownCifs--;
        }, 1000);
        this.finish = false;
        this.nullTimer();
        this.local_steps++;
        setTimeout(() => {
          clearInterval(this.timerId);
          this.currentStep = 'cifers';
          this.countDownCifs = 2;
          this.startTimer();
          this.showCifers();
        }, 3000);
      },
      /** Показываем цифры по таймеру */
      showCifers() {
        this.currentStep = 'cifers';
        let cifers = this.cifers;
        let speed = this.params.speed * 1000;
        let app = this;
        let i = 0;
        console.log(cifers);
        this.currentCif = cifers[i];
        //this.playVoice(cifers[i]);
        this.playMentalSound(cifers[i]);
        this.timerId = setInterval(function () {
          i++;
          app.dots++;
          app.currentCif = cifers[i]
          if (i !== app.params.terms) {
            app.playMentalSound(cifers[i]);
          } else {
            app.playMentalSound();
          }
          //app.playVoice(cifers[i]);
        }, speed);
        setTimeout(() => {
          clearInterval(this.timerId);
          app.$parent.full_check = true;
          app.currentStep = 'answer';
          setTimeout(function () {
            if (app.users > 1) {
              //$('#check').focus();
              //$('#game_input-1').focus();
            } else {
              $('#game_input-' + app.inkey).focus();
            }
          }, 300);

        }, speed * cifers.length);
      },
      /** Проверяем ответ */
      checkAnswer2() {
        if (this.users > 1) {
          this.$root.$emit('fullCheck');
        } else {
          this.checkAnswer();
        }
      },
      checkAnswer() {
        if (this.currentStep !== 'result' && this.preStart) {
          console.log('CHeck answer');
          if (this.userNumber || this.users > 1) {
            console.log('Прошел');
            this.preStart = false;
            this.checkError();
            let app = this;
            this.$emit('localChanged');
            let result = {
              cifers: this.cifers,
              sum: this.sum,
              user_answer: +this.userNumber,
              timer: this.timer
            };
            this.results.push(result);
            this.local_results.push(result);
            setTimeout(function () {
              //app.userNumber = '';
              if (app.step === app.params.steps) {
                app.currentStep = 'result';
                app.addScores();
                if (app.local_steps > 1 && app.stat_id) {
                  app.updateStats();
                } else {
                  app.makeStats();
                }

                setTimeout(function () {
                  if (app.users === 1) {
                    $('#repeat-' + app.inkey).focus();
                  } else {
                    //$('#start').focus();
                  }
                }, 100);

              } else {
                app.step++;
                setTimeout(function () {
                  app.reset(false);
                }, 100);
              }
            }, 1000);
            this.finish = true;
            this.startReaction();
          }
        }
      },
      /** Устанавливаем статус результата */
      setStatus(val) {
        let app = this;
        this[val] = true;
        setTimeout(function () {
          app[val] = false;
        }, 1000)
      },
      /** Проверяем есть ли ошибки */
      checkError() {
        this.userNumber = Number(this.userNumber.replace(/\D+/g,""));
        if (this.sum == this.userNumber) {
          this.setStatus('is_success');
          this.playBeeSound('yes1');
          //this.result = this.currentNumber + " = "+ this.userNumber;
        } else {
          this.setStatus('is_error');
          this.playBeeSound('no');
          //this.result = this.currentNumber + " <span class='fn'>≠</span> "+ this.userNumber;
          this.errors++;
        }
      },

      fullReset() {
        this.step = 1;
        this.scores = 0;
        this.results = [];
        this.reset();
      },
      /** Сбрасываем значения */
      reset(nocd = false) {
        this.nextNum = '';
        this.startApp(nocd);
        //this.startGame();
      },
      /** Останавливаем игру */
      stopGame() {
        this.active = false;
      },


      /**
       *
       * ЗДЕСЬ СТАРТ ПРИЛОЖЕНИЯ
       *
       * */

      /** Перед запуском проверяем - ученик или учитель */
      preStartApp() {
        if (this.role === 'teacher') {
          //console.log('Учителю старт не положен');
	        this.preStart = false;
          this.currentStep = 'preStart';
        } else {
          this.startApp();
        }
      },
      /** Запуск приложения */
      startApp(nocd = false) {
        if(this.timerId) clearInterval(this.timerId);
        console.log('Нажимаем start app', this.preStart);
        if (!this.preStart) {
          this.$root.wait = true;
          this.preStart = true;
          //this.$emit('localChanged');
          let app = this;
          setTimeout(function () {
            app.generatorBase();
            app.$root.wait = false;
            //app.currentStep = 'result';
            app.startGame(nocd);
            if (!nocd) {
              app.currentStep = 'ready';
            }
            app.stopGame();
          }, 200);
        }
      },
      /** Применяем параметры из внешнего окна */
      params_changed(val) {
        this.params = val;
        this.preStartApp();
        this.$emit('localChanged');
      },
      /** Управляем настройками */
      setShowsettings() {
        this.showsettings = !this.showsettings;
        /*if (this.showsettings) {
          $(document.body).addClass('fixed');
        } else {
          $(document.body).removeClass('fixed');
        }*/
      },


      /** Параметры для одновременного запуска */
      init() {
        this.$root.$on('fullStart', this.fullReset);
        this.$root.$on('fullCheck', this.checkAnswer);
        let app = this;
        if (this.users > 1) {
          $('#start').focus();
        } else {
          setTimeout(function () {
            $('#start-' + app.inkey).focus();
          }, 100);
        }
      },
      /** Озвучка */
      playVoice(num) {
        if (num && this.users === 1 && this.params.voice && this.params.speed > 0.7) {
          //console.log('PlayVoice', num);
          let voice = this.voice;
          voice.lang = "ru-RU";
          voice.text = num > 0 ? '+' + num : num;
          voice.rate = 6;
          voice.pitch = 1.8;
          voice.volume = 1;
          window.speechSynthesis.speak(voice);
        }
      },

      /** РЕАКЦИИ */
      startReaction() {
        if (this.users === 1 && this.params.steps == 1 && this.params.show_reactions) {
          let type = (this.userNumber == this.sum ? 'react_plus' : 'react_minus');
          let reaction_file = this.checkReaction(type);
          //console.log(arr);
          //console.log(reaction_file);
          this.reaction_file = reaction_file;
          this.reaction = true;
          setTimeout(function () {
            UIkit.scroll('.headline2').scrollTo('.wh-block--reaction');
          }, 100);
        }
      },
      stopReaction() {
        this.reaction = false;
        let app = this;
        setTimeout(function () {
          UIkit.scroll('.headline2').scrollTo('.game__body');
          $('#repeat-' + app.inkey).focus();
        }, 100);
      },

      initVoice() {
        var hasWindow = typeof window === 'object' && window !== null && window.self === window && window.navigator !== null
        var bIsiOS = hasWindow && /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
        var iOSVoiceNames = [
          'Milena',
        ]
        var voices = speechSynthesis.getVoices()
        if (bIsiOS) {
          let iOSVoices = []
          for (var i = 0; i < voices.length; ++i) {
            if (iOSVoiceNames.includes(voices[i].name)) {
              iOSVoices.push(voices[i])
            }
          }
          voices = iOSVoices
        }
        this.voice = new SpeechSynthesisUtterance();
      },

      addScores() {
        //console.log('Add scores');
        let sum = 0;
        let result = this.results;
        let from = this.minAxis;
        let to = this.maxAxis;
        let speed = this.params.speed;
        let cif;
        let terms = this.params.terms;
        if (from === to) {
          cif = to;
        } else {
          cif = to - 0.5;
        }

        result.forEach(function (e) {
          console.log(e);
          if (e.sum === e.user_answer) {
            console.log(sum, terms, cif);
            sum = sum + ((terms * (cif * cif)) / speed);
          } else {
            console.log('Ошибки не считаем');
          }
        });
        sum = Math.ceil(sum);

        if(this.$route.params.isHomework){
          sum = Math.ceil(sum * this.$store.state.hw_coefficient);
        }
        this.checkScoreStatus(sum);
        this.scores = sum;
        this.$store.commit('changeUserScores', sum);
        console.log('Баллов заработано', sum);
      },

      makeStats() {
        if (this.user.role.code === 'student') {
					let path = this.$route.params.is_matrius ? 'onSaveMatriusAnswer' : 'onSaveStats'
          console.log('Бережно сохраняем статистику');
          let app = this;
          let errors = this.errors;
          let train_params = this.params;
          let stats = {
            total: this.getTotalTime(this.results),
            errors: errors,
            user_id: this.$store.state.user.id,
            trainer: this.$store.state.current_trainer.id,
            count: this.local_steps,
            results: this.results,
            scores: this.scores,
            train_params: {
              formula: train_params.formula,
              speed: train_params.speed,
              rank: train_params.rank,
              terms: train_params.terms,
              cifers: train_params.cifers,
              cifers_dop: train_params.cifers_dop,
            }
          }

					if (this.$route.params.is_matrius) {
						stats.student_task_id = this.$route.params.student_task_id
						stats.qnt = this.$route.params.qnt
					}

          stats = this.checkHomework(stats);
          console.log(stats);

          axios.post(window.location.href, { 'stat': stats }, {
            headers: {
              'X-OCTOBER-REQUEST-HANDLER': path,
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (res) {
            //console.log(res);
            app.stat_id = res.data.id;
            app.checkCoins(res.data);
          });

        } else {
          console.log('Учителей в статистику не заносим! Понятно?!');
        }
      },

      updateStats() {
        if (this.user.role.code === 'student') {
          console.log('Update stats');
          let results = this.local_results;
          let time = this.getTotalTime(results);
          let stat_id = this.stat_id;
          let arr = {
            result: results,
            time: time,
            errors: this.errors,
            stat_id: stat_id,
            count: this.local_steps,
            scores: this.scores,
	          isHomework: this.$route.params.isHomework ? true : false
          }
          console.log(arr);
          this.updateHomework();
          axios.post(window.location.href, { 'stat': arr }, {
            headers: {
              'X-OCTOBER-REQUEST-HANDLER': 'onUpdateStats',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then((res) => {
            this.checkCoins(res.data);
            //console.log(res);
          });

        }
      },

      getTotalTime(arr) {
        return _.reduce(arr, function (sum, i) {
          return sum + i.timer.total_ms;
        }, 0);
      }

    },
    mounted() {
      this.preStart = false;
      this.$emit('localChanged');
      this.init();
      //this.initVoice();
      this.params = _.cloneDeep(this.$store.state.train.mental_params);
      this.preStartApp();
      /*let app = this;
      setTimeout(function () {
        console.log('play');
        app.playChain(['minus', '200', '60', '3']);
      }, 1000);*/

      //this.breakNumber(-51);
      /*let app = this;
      let p = '40';
      setTimeout(function () {
	      app.playChain([p, '1', p, '2', p, '3', p, '4', p, '5', p, '6', p, '7', p, '8', p, '9']);
      }, 1000)*/
    },
    beforeDestroy() {
      clearInterval(this.timerId);
      this.$root.$off('fullStart', this.fullReset);
      this.$root.$off('fullCheck', this.checkAnswer);
    }
  }
</script>

<style lang="scss" scoped>
.flash__message {
  width: 100%;
}
</style>